<template>
    <a-card class='wrap-info ant-card-small' :title="`${assetCard}`">
        <div slot="extra">
            <img src="../assets/images/Ripple-1s-32px.svg" alt="">
        </div>

        <a-row>
            <a-col class="ant-col-name" :md="6">设备编号</a-col>
            <a-col class="ant-col-value" :md="18">{{ assetInfo.number }}</a-col>
        </a-row>

        <a-row v-if="assetInfo.assetBrand">
            <a-col class="ant-col-name" :md="6">生产厂商</a-col>
            <a-col class="ant-col-value" :md="18">{{ assetInfo.assetBrand }}</a-col>
        </a-row>

        <a-row v-if="assetInfo.assetModel">
            <a-col class="ant-col-name" :md="6">型号</a-col>
            <a-col class="ant-col-value" :md="18">{{ assetInfo.assetModel }}</a-col>
        </a-row>

        <a-row v-if="assetInfo.norms">
            <a-col class="ant-col-name" :md="6">主要规格</a-col>
            <a-col class="ant-col-value" :md="18">{{ assetInfo.norms }}</a-col>
        </a-row>

        <a-row v-if="assetInfo.startDate">
            <a-col class="ant-col-name" :md="6">启用日期</a-col>
            <a-col class="ant-col-value" :md="18">{{ assetInfo.startDate }}</a-col>
        </a-row>

        <a-row v-if="assetInfo.runningStatus">
            <a-col class="ant-col-name" :md="6">运行状态</a-col>
            <a-col class="ant-col-value" :md="18">{{ assetInfo.runningStatus }}</a-col>
        </a-row>

        <a-spin :spinning="isLoadingWorking">
            <template v-if="!isLoadingWorking && typeof assetInfo.workingTask.isShowWorkingTask !== 'undefined' && assetInfo.workingTask.isShowWorkingTask === true">
                <a-row class="asset-working-title">
                    <a-col class="ant-col-name" :md="24">正在加工</a-col>
                </a-row>

                <a-row>
                    <a-col class="ant-col-value" :md="24">
                        <a-progress :percent=" assetInfo.workingTask.progress" :showInfo="false" />
                    </a-col>
                </a-row>

                <a-row style="margin-top: -5px;">
                    <a-col class="ant-col-name ant-col-value-left" :md="12">{{ assetInfo.workingTask.start_date }}</a-col>
                    <a-col class="ant-col-name ant-col-value-right" :md="12">{{ assetInfo.workingTask.end_date }}</a-col>
                </a-row>

                <a-row>
                    <a-col class="ant-col-value ant-col-value-left" :md="24">{{ assetInfo.workingTask.productName }}</a-col>
                </a-row>

                <a-row>
                    <a-col class="ant-col-value ant-col-value-left" :md="24">{{ assetInfo.workingTask.projectName }}</a-col>
                </a-row>

                <a-row>
                    <a-col class="ant-col-value ant-col-value-left" :md="12">{{ assetInfo.workingTask.marterialName }}</a-col>
                    <a-col class="ant-col-value ant-col-value-right" :md="12">{{ assetInfo.workingTask.qty }}</a-col>
                </a-row>
            </template>

            <template v-if="!isLoadingWorking && typeof assetInfo.queueTask.isShowQueueTask !== 'undefined' && assetInfo.queueTask.isShowQueueTask === true">
                <a-row class="asset-working-title">
                    <a-col class="ant-col-name" :md="24">排队任务</a-col>
                </a-row>

                <a-row>
                    <a-col class="ant-col-value ant-col-value-left" :md="24">{{ assetInfo.queueTask.productName }}</a-col>
                </a-row>

                <a-row>
                    <a-col class="ant-col-value ant-col-value-left" :md="24">{{ assetInfo.queueTask.projectName }}</a-col>
                </a-row>
            </template>
        </a-spin>
    </a-card>
</template>

<script>
    export default {
        name: 'BasicAssetCard',

        components: {},

        props: ['assetCard', 'assetInfo'],

        data ()
        {
            return {
                isLoadingWorking: true,
            }
        },

        computed: {},

        watch: {},

        mounted: function ()
        {
            const self = this;

            if(
                (typeof self.assetInfo.workingTask.isShowWorkingTask !== 'undefined' && self.assetInfo.workingTask.isShowWorkingTask === true)
                || (typeof self.assetInfo.queueTask.isShowQueueTask !== 'undefined' && self.assetInfo.queueTask.isShowQueueTask === true)
            )
            {
                self.isLoadingWorking = true;
            }
            else
            {
                self.isLoadingWorking = false;
            }

            // 1s钟后关闭加载中
            self.$nextTick(() => {
                setTimeout(() => {
                    self.isLoadingWorking = false;
                }, 1500)
            })
        },

        methods: {}
    }
</script>

<style lang="scss" scoped>
    .asset-working-title {
        margin-left: -12px;
        margin-right: -12px;
        padding: 5px 10px;
        font-size: 18px;
        font-weight: 600;
        border-top: 2px solid rgba(204, 204, 204, 0.5);
        background: rgba(0, 0, 50, 0.4) !important;
    }

    ::v-deep .ant-spin-dot-item {
        background-color: white !important;
    }
</style>
